export default __webpack_public_path__ + "static/media/Add.c6da17ef.svg";